import generalRoutes from './routes'

/* @ngInject */
const generalRoute = (
  $stateProvider
) => {
  $stateProvider
    .state(generalRoutes.index.path, {
      url: generalRoutes.index.url,
      controller: 'generalCtrl',
      template: require('./templates/index.html'),
    })
}

export default generalRoute



// WEBPACK FOOTER //
// ./public/javascript/sygem/routing/setting/general/general.routes.js